export type UiComponents = {
  file_gallery: {
    of: string;
    delete_file_modal_header: string;
    delete_file_modal_body: string;
  };
  download_button: string;
  delete_button: string;
  confirm_button: string;
  cancel_button: string;
  confirm: string;
};

export const UiComponentsEn: UiComponents = {
  file_gallery: {
    of: "of",
    delete_file_modal_header: "Delete file",
    delete_file_modal_body: "Are you sure you want to delete this file?",
  },
  download_button: "Download",
  delete_button: "Delete",
  confirm_button: "Confirm",
  cancel_button: "Cancel",
  confirm: "Confirm",
};

export const UiComponentsEs: UiComponents = {
  file_gallery: {
    of: "de",
    delete_file_modal_header: "Eliminar esta foto?",
    delete_file_modal_body:
      "Esta acción no se puede deshacer. Esto eliminará permanentemente tu foto de nuestros servidores.",
  },
  download_button: "Descargar",
  delete_button: "Borrar",
  confirm_button: "Confirmar",
  cancel_button: "Cancelar",
  confirm: "Confirmar",
};
